export default __webpack_public_path__ + "static/brick-display-pro-black-45f480d79cfd12c1b8cff206ad0762d5.woff2";